import { Component, ElementRef, Inject } from "@angular/core";
import { IdentityService } from "@common/identity/identity.service";
import { ElementUtilities } from "@common/lib/utilities/element-utilities";
import { CommonSidebarConstants } from "@common/shell/common-sidebar/common-sidebar.constants";
import { ShellUiService } from "@common/shell/shell-ui.service";
import { ThemeService } from "@common/shell/theme.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { debounceTime, merge, Observable, tap } from "rxjs";
import { CHAT_AI_ORG_PROVIDER, IChatAiOrgProvider } from "../chat-ai-org-provider.interface";
import { ChatAiUiService, ChatLocationMode } from "../chat-ai-ui.service";

@Component({
    selector: "adapt-chat-ai-sidebar-content",
    standalone: false,
    templateUrl: "./chat-ai-sidebar-content.component.html",
    styleUrls: ["./chat-ai-sidebar-content.component.scss"],
})
export class ChatAiSidebarContentComponent extends BaseComponent {
    public showingContentInSidebar$: Observable<boolean>;
    public totalCost = 0;
    // this is to destroy the component instance when organisation is switching to avoid issues with leftover organisation specific data in the component after the switch
    public isOrganisationChanging = false;

    public constructor(
        public shellUiService: ShellUiService,
        public themeService: ThemeService,
        chatAiUiService: ChatAiUiService,
        @Inject(CHAT_AI_ORG_PROVIDER) orgService: IChatAiOrgProvider,
        identityService: IdentityService,
        elementRef: ElementRef,
    ) {
        super(elementRef);
        this.showingContentInSidebar$ = chatAiUiService.isFeatureEnabledForLocationMode$(ChatLocationMode.Sidebar).pipe(
            tap((chatOnSidebar) => setTimeout(() => {
                if (!chatOnSidebar && ElementUtilities.isVisible(elementRef.nativeElement)) {
                    // if the current page has a corresponding nav node, it would have already gone to the nav sidebar.
                    // if landed here -> will need to redirect to org tab or chat sidebar will be left behind with empty content
                    this.shellUiService.focusTab(CommonSidebarConstants.OrganisationSidebarId);
                }
            })),
        );
        merge(orgService.organisationSwitching$, identityService.identity$).pipe(
            this.takeUntilDestroyed(),
        ).subscribe(() => this.isOrganisationChanging = true);
        orgService.organisationChanged$.pipe(
            debounceTime(300),
            this.takeUntilDestroyed(),
        ).subscribe(() => this.isOrganisationChanging = false);
    }
}
